import { use3DEffect } from 'components/SecretIdentity/use3DEffect'
import { PropsWithChildren } from 'react'
import Styles from './Popout3D.module.scss'
import { Popout3DProps } from 'components/SecretIdentity/Types'
import cx from 'classnames'

export const Popout3D = ({ children, percentage = 10, fullWidth = false }: PropsWithChildren<Popout3DProps>) => {
  const { cardRef, containerRef } = use3DEffect<HTMLDivElement>()
  const styles = {
    '--popout-percentage': percentage,
  } as React.CSSProperties

  return (
    <div className={cx(Styles.root, { [Styles.fullWidth]: fullWidth })} ref={containerRef} style={styles}>
      <div className={Styles.content} ref={cardRef}>
        {children}
      </div>
    </div>
  )
}
